import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip
} from '@mui/material';

interface AuditEntry {
  id: string;
  action: string;
  user: string;
  timestamp: string;
  category: 'access' | 'modification' | 'export';
  details: string;
}

const mockAuditTrail: AuditEntry[] = [
  {
    id: '1',
    action: 'Student Record Access',
    user: 'Jane Smith',
    timestamp: '2023-08-10 14:30',
    category: 'access',
    details: 'Viewed student ID: 12345'
  },
  {
    id: '2',
    action: 'Intervention Plan Modified',
    user: 'John Doe',
    timestamp: '2023-08-10 13:15',
    category: 'modification',
    details: 'Updated intervention plan for student ID: 12345'
  },
  {
    id: '3',
    action: 'Report Export',
    user: 'Jane Smith',
    timestamp: '2023-08-10 11:45',
    category: 'export',
    details: 'Generated attendance report for Grade 9'
  }
];

const getCategoryColor = (category: string) => {
  switch (category) {
    case 'access':
      return 'info';
    case 'modification':
      return 'warning';
    case 'export':
      return 'success';
    default:
      return 'default';
  }
};

export const AuditTrail: React.FC = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Audit Trail
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Timestamp</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mockAuditTrail.map((entry) => (
              <TableRow key={entry.id}>
                <TableCell>{entry.timestamp}</TableCell>
                <TableCell>{entry.user}</TableCell>
                <TableCell>{entry.action}</TableCell>
                <TableCell>
                  <Chip
                    label={entry.category}
                    color={getCategoryColor(entry.category)}
                    size="small"
                  />
                </TableCell>
                <TableCell>{entry.details}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};